<template>
  <Category />
</template>

<script>
import Category from '@/components/Categories/Category';
import { validateCategoryId } from '~/utils/common.js';
import { mapGetters } from 'vuex';

export default {
  nuxtI18n: {
    paths: {
      en: '/category/:id/:slug/p/:page',
      de: '/category/:id/:slug/p/:page',
      es: '/categoria/:id/:slug/p/:page',
      pt: '/categoria/:id/:slug/p/:page'
    }
  },
  components: {
    Category
  },
  async validate({ params, store, app: { $urlBuilder }, route, redirect }) {
    await store.dispatch('categories/LOAD_CATEGORY', { id: params.id });
    const category = store.state.categories.category;
    return validateCategoryId(category, route.path, params, $urlBuilder, redirect);
  },
  async asyncData({ store, route }) {
    const params = route.params;
    const currentPage = params.page ? parseInt(params.page) : 1;

    store.dispatch('categories/CLEAN_CATEGORIES');
    await store.dispatch('categories/LOAD_CATEGORY_CONTENT', {
      id: params.id,
      page: currentPage
    });

    const { en, de, es, pt } = store.state.categories.metadata;
    const slugs = {
      en: { slug: en },
      de: { slug: de },
      es: { slug: es },
      pt: { slug: pt }
    };
    store.dispatch('i18n/setRouteParams', slugs);
  },
  head() {
    const { id, slug } = this.$store.state.categories.category;
    const canonical = this.$canonicalPlugin(
      `/category/${id}/${slug}`,
      this.$store.$i18n.locale,
      true
    );
    const i18nSeo = this.$seoPlugin({ hreflang: false, canonical: false });
    const openGraph = this.$openGraphPlugin(
      this.getMetadata?.metaTitle,
      'website',
      this.$route.path,
      this.getMetadata?.metaDescription,
      this.getImageFirstResult,
      this.$store.state.i18n.locale
    );
    return {
      title: this.getMetadata?.metaTitle,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, follow' },
        {
          hid: 'description',
          name: 'description',
          content: this.getMetadata?.metaDescription
        },
        ...openGraph
      ],
      link: [canonical, ...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('categories', ['getMetadata', 'getImageFirstResult'])
  }
};
</script>
